window.addEventListener('load',function(){
    diagnosisPopup();
    
    var agent = navigator.userAgent;
    if(agent.search(/iPhone/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){
        spStyle();
    }

    
});

function diagnosisPopup(){
    
    var startBtnWrap = document.getElementById('diagnosis');
    var popup = document.getElementById('diagCont');
    var upJudges = popup.classList;
    var upJudge = Array.prototype.slice.call(upJudges)[0];
    var startBtns = startBtnWrap.getElementsByTagName('p');
    var startBtn = Array.prototype.slice.call(startBtns)[0];
    var yess = popup.getElementsByClassName('diagYes');
    var yes = Array.prototype.slice.call(yess)[0];
    var nos = popup.getElementsByClassName('diagNo');
    var no = Array.prototype.slice.call(nos)[0];
    var closeButtons = popup.getElementsByClassName('closeBtn');
    var closeBtn = Array.prototype.slice.call(closeButtons)[0];
    var backs = popup.getElementsByClassName('background');
    var back = Array.prototype.slice.call(backs)[0];
    var conts = popup.getElementsByClassName('contCont');
    var contQ = Array.prototype.slice.call(conts)[0];
    var contA = Array.prototype.slice.call(conts)[1];
    //var qCont = cont.innerHTML;
    var contents = popup.getElementsByClassName('cont');
    var content = Array.prototype.slice.call(contents)[0];
    
    
    
    startBtn.addEventListener('click',function(){
        diagnosisOpen();
    });
    closeBtn.addEventListener('click',function(){
        diagnosisClose();
    });
    back.addEventListener('click',function(){
        diagnosisClose();
    });
    yes.addEventListener('click',function(){
        console.log('発動');
        var yesClicks = popup.getElementsByClassName('diagYes');
        var yesClick = Array.prototype.slice.call(yess)[0];
        yesClick.classList.add('onClick');
        diagnosisSystem();
    });
    no.addEventListener('click',function(){
        var noClicks = popup.getElementsByClassName('diagNo');
        var noClick = Array.prototype.slice.call(nos)[0];
        noClick.classList.add('onClick');
        diagnosisSystem();
    });
    
    function diagnosisOpen(){
            if(upJudge.indexOf('close') != -1){
                popup.classList.remove('close');
                popup.classList.add('open');
            }else if(upJudge.indexOf('open') != -1){
                popup.classList.remove('open');
                popup.classList.add('close');
            }
    }
    function diagnosisClose(){
        popup.classList.remove('open');
        popup.classList.add('close');
        diagStart();
    }
    //はじめに戻す
    function diagStart(){
        contA.style.display = "none";
        contQ.style.display = "block";
        var backChecks = back.classList;
        var backCheck = Array.prototype.slice.call(backChecks);
        var contentChecks = content.classList;
        var contentCheck = Array.prototype.slice.call(contentChecks);
        if(backCheck.indexOf('resultBack') != -1){
            back.classList.remove('resultBack');
        }
        if(contentCheck.indexOf('answerCont') != -1){
            content.classList.remove('answerCont');
        }
    }
    function diagnosisSystem(){
        var questions = popup.getElementsByClassName('diagQ');
        var question = Array.prototype.slice.call(questions)[0];
        var answers = popup.getElementsByClassName('diagA');
        var answer = Array.prototype.slice.call(answers)[0];
        var questionwords = popup.getElementsByClassName('quest');
        var questionword = Array.prototype.slice.call(questionwords)[0];
        var diagWrap = document.getElementById('diagCont');
        var qNum = question.getAttribute('questNo');
        var q1 = document.getElementById('contNo1');
        var target = content.innerHTML;
        var yesChecks = yes.classList;
        var yesCheck = Array.prototype.slice.call(yesChecks);
        var noChecks = no.classList;
        var noCheck = Array.prototype.slice.call(noChecks);
        var negaeri = '<span class="linear">Q2.寝返りを打つことが多い</span>';
        var yawarakame = '<span class="linear">Q3.やわらかめの寝心地が好きだ</span>';
        var katame = '<span class="linear">Q3.硬めの寝心地が好きだ</span>';
        var nedan = '<span class="linear">Q4.良質な睡眠のため、<br>素材や品質にはこだわりたい</span>';
        //診断結果
        var resultSoufle = '<dl><dt>診断結果</dt><dd><h3 class="diagTtl"><span class="">おすすめのタイプはこちら</span></h3></dd></dl><div class="aImg"><img src="https://cdn.shopify.com/s/files/1/0635/1234/6790/files/about-mattress-soufle.png"></div><div class="diagQ aItem" questNo="result"><p class="quest"><span class="linear">超高密度ポケットコイルマットレス<br>スフレ</span></p></div><div class="aPoint"><h4>POINT</h4><ul><li class="text">◎やわらかな寝心地と適度な反発性を兼ね備えているため、沈み込みすぎず、寝返りが打ちやすいのが特長です。（初めてのマットレスや、硬さの好みが異なる人と一緒にご使用いただくのもおすすめ）</li><li class="text">◎高品質素材を使用した、ホテルのベッドのような寝心地。睡眠の質にこだわりたい方に特におすすめです。</li></ul></div><div class="itemLook"><p class="unico-button-area -type-vertical"><a class="unico-button -icon-anchor -type-square -color-dark" href="#soufle">商品の特長を詳しく見る</a></p></div>';
        var resultHighbound = '<dl><dt>診断結果</dt><dd><h3 class="diagTtl"><span class="">おすすめのタイプはこちら</span></h3></dd></dl><div class="aImg"><img src="https://cdn.shopify.com/s/files/1/0635/1234/6790/files/about-mattress-highbound.png"></div><div class="diagQ aItem" questNo="result"><p class="quest"><span class="linear">超高密度ポケットコイルマットレス<br>ハイバウンド</span></p></div><div class="aPoint"><h4>POINT</h4><ul><li class="text">◎高反発フォームを使用。沈み込みが少ないので、腰痛をお持ちの方や男性、立ち上がり時の負担を減らしたい方におすすめです。</li><li class="text">◎寝返りが打ちやすく、揺れや沈み込みを抑え、安定した寝姿勢を保ってくれます。</li></ul></div><div class="itemLook"><p class="unico-button-area -type-vertical"><a  class="unico-button -icon-anchor -type-square -color-dark" href="#highbound">商品の特長を詳しく見る</a></p></div>';
        var resultSara = '<dl><dt>診断結果</dt><dd><h3 class="diagTtl"><span class="">おすすめのタイプはこちら</span></h3></dd></dl><div class="aImg"><img src="https://cdn.shopify.com/s/files/1/0635/1234/6790/files/about-mattress-sara.png"></div><div class="diagQ aItem" questNo="result"><p class="quest"><span class="linear">ポケットコイルマットレス<br>サラブライト</span></p></div><div class="aPoint"><h4>POINT</h4><ul><li class="text">◎やわらかく、包み込まれるような寝心地のサラブライトフォームを使用。寝姿勢が安定し、寝返りが減ります。</li><li class="text">◎なめらかで、しっとりとした肌ざわりが魅力。吸放湿性にもすぐれ、ぐっすりと長時間寝たい方や、女性にもおすすめです。</li></ul></div><div class="itemLook"><p class="unico-button-area -type-vertical"><a  class="unico-button -icon-anchor -type-square -color-dark" href="#sara">商品の特長を詳しく見る</a></p></div>';
        var resultRyomen = '<dl><dt>診断結果</dt><dd><h3 class="diagTtl"><span class="">おすすめのタイプはこちら</span></h3></dd></dl><div class="aImg"><img src="https://cdn.shopify.com/s/files/1/0635/1234/6790/files/about-mattress-ryoumen.png"></div><div class="diagQ aItem" questNo="result"><p class="quest"><span class="linear">ポケットコイルマットレス<br>両面タイプ</span></p></div><div class="aPoint"><h4>POINT</h4><ul><li class="text">◎裏返して湿気を防いだり、へたりを防止したり、定期的にお手入れができます。</li><li class="text">◎他のマットレスに比べ厚さが薄いため※、ベッドフレームのデザインをそこないません。<span class="smallTxt">※当社製品との比較</span></li></ul></div><div class="itemLook"><p class="unico-button-area -type-vertical"><a  class="unico-button -icon-anchor -type-square -color-dark" href="#ryomen">商品の特長を詳しく見る</a></p></div>';
        //質問1段目
        if(qNum == '1' && yesCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','2');
            questionword.innerHTML = negaeri;
            yes.classList.remove('onClick');
        }else if(qNum == '1' && noCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','3');
            questionword.innerHTML = negaeri;
            no.classList.remove('onClick');
        }else if(qNum == '2' && yesCheck.indexOf('onClick') != -1){//２段目
            question.setAttribute('questNo','4');
            questionword.innerHTML = yawarakame;
            yes.classList.remove('onClick');
        }else if(qNum == '2' && noCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','5');
            questionword.innerHTML = yawarakame;
            no.classList.remove('onClick');
        }else if(qNum == '3' && yesCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','6');
            questionword.innerHTML = katame;
            yes.classList.remove('onClick');
        }else if(qNum == '3' && noCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','7');
            questionword.innerHTML = yawarakame;
            no.classList.remove('onClick');
        }else if(qNum == '4' && yesCheck.indexOf('onClick') != -1){//３段目
            //スフレ
            diagResult(resultSoufle);
            yes.classList.remove('onClick');
        }else if(qNum == '4' && noCheck.indexOf('onClick') != -1){
            //ハイバウンド
            diagResult(resultHighbound);
            no.classList.remove('onClick');
        }else if(qNum == '5' && yesCheck.indexOf('onClick') != -1){
            //スフレ
            diagResult(resultSoufle);
            yes.classList.remove('onClick');
        }else if(qNum == '5' && noCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','9');
            questionword.innerHTML = nedan;
            no.classList.remove('onClick');
        }else if(qNum == '6' && yesCheck.indexOf('onClick') != -1){
            //ハイバウンド
            diagResult(resultHighbound);
            yes.classList.remove('onClick');
        }else if(qNum == '6' && noCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','9');
            questionword.innerHTML = nedan;
            no.classList.remove('onClick');
        }else if(qNum == '7' && yesCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','10');
            questionword.innerHTML = nedan;
            yes.classList.remove('onClick');
        }else if(qNum == '7' && noCheck.indexOf('onClick') != -1){
            question.setAttribute('questNo','11');
            questionword.innerHTML = nedan;
            no.classList.remove('onClick');
        }else if(qNum == '8' && yesCheck.indexOf('onClick') != -1){//４段目
            //スフレ
            diagResult(resultSoufle);
            yes.classList.remove('onClick');
        }else if(qNum == '8' && noCheck.indexOf('onClick') != -1){
            //両面
            diagResult(resultRyomen);
            no.classList.remove('onClick');
        }else if(qNum == '9' && yesCheck.indexOf('onClick') != -1){
            //スフレ
            diagResult(resultSoufle);
            yes.classList.remove('onClick');
        }else if(qNum == '9' && noCheck.indexOf('onClick') != -1){
            //両面
            diagResult(resultRyomen);
            no.classList.remove('onClick');
        }else if(qNum == '10' && yesCheck.indexOf('onClick') != -1){
            //スフレ
            diagResult(resultSoufle);
            yes.classList.remove('onClick');
        }else if(qNum == '10' && noCheck.indexOf('onClick') != -1){
            //サラブライト
            diagResult(resultSara);
            no.classList.remove('onClick');
        }else if(qNum == '11' && yesCheck.indexOf('onClick') != -1){
            //ハイバウンド
            diagResult(resultHighbound);
            yes.classList.remove('onClick');
        }else if(qNum == '11' && noCheck.indexOf('onClick') != -1){
            //両面
            diagResult(resultRyomen);
            no.classList.remove('onClick');
        }
        
        function diagResult(result){
            contA.innerHTML = result;
            var koshi = '<span class="linear">Q1.腰痛がある</span>';
            question.setAttribute('questNo','1');
            questionword.innerHTML = koshi;
            contQ.style.display = "none";
            back.classList.add('resultBack');
            content.classList.add('answerCont');
            contA.style.display = "block";
            content.style.marginTop = "50px";
            var contAH = contA.clientHeight;
            back.style.height = contAH + 100 + 'px';
            var itemBtns = popup.getElementsByClassName('itemLook');
            var itemBtn = Array.prototype.slice.call(itemBtns)[0];
            itemBtn.addEventListener('click',function(){
                diagnosisClose();
            });
        }
    }
}

function spStyle(){
    
    var wraps = document.getElementsByClassName('choice');
    var wrap = Array.prototype.slice.call(wraps)[0];
    
    fit();
    
    function fit(){
        
        var firsts = wrap.getElementsByClassName('point');
        var first = Array.prototype.slice.call(firsts)[1];
        var lists = first.getElementsByTagName('li');
        
        var listFir = Array.prototype.slice.call(lists)[0];
        var listFirHTML = listFir.outerHTML;
        var listSec = Array.prototype.slice.call(lists)[1];
        var listSecHTML = listSec.innerHTML;
        var listLast = Array.prototype.slice.call(lists)[2];
        var sentence = listLast.getElementsByTagName('p');
        var senFir = Array.prototype.slice.call(sentence)[0];
        var senFirHTML = senFir.outerHTML;
        var senSec = Array.prototype.slice.call(sentence)[1];
        var senSecHTML = senSec.outerHTML;
        
        listLast.outerHTML = '';
        
        listFir.outerHTML = listFir.outerHTML + senFirHTML;
        listSec.outerHTML = listSec.outerHTML + senSecHTML;
        
        var nones = listFir.getElementsByClassName('miniTtl');
        var none = Array.prototype.slice.call(nones);
        none.forEach(function(value){
            value.outerHTML = '';
        });

    }

}